var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdvantagesIndividual(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6591 13.1818C20.1618 13.1818 24.75 14.1169 24.75 17.8571C24.75 19.4935 24.3329 19.7273 23.4987 19.7273L16.8548 19.7281C17.0272 19.1946 17.1136 18.5688 17.1136 17.8571C17.1136 15.9777 16.4249 14.5115 15.2899 13.4261C16.1441 13.2509 16.9787 13.1818 17.6591 13.1818ZM7.84091 13.1818C10.3436 13.1818 14.9318 14.1169 14.9318 17.8571C14.9318 19.4935 14.5147 19.7273 13.6805 19.7273H2.00134C1.16711 19.7273 0.75 19.4935 0.75 17.8571C0.75 14.1169 5.33824 13.1818 7.84091 13.1818ZM7.84091 5C9.64909 5 11.1136 6.46455 11.1136 8.27273C11.1136 10.0809 9.64909 11.5455 7.84091 11.5455C6.03273 11.5455 4.56818 10.0809 4.56818 8.27273C4.56818 6.46455 6.03273 5 7.84091 5ZM17.6591 5C19.4673 5 20.9318 6.46455 20.9318 8.27273C20.9318 10.0809 19.4673 11.5455 17.6591 11.5455C15.8509 11.5455 14.3864 10.0809 14.3864 8.27273C14.3864 6.46455 15.8509 5 17.6591 5Z",
    fill: "url(#paint0_linear_6314_84591)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6314_84591",
    x1: 12.75,
    y1: 5,
    x2: 12.75,
    y2: 19.7281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC92ED",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC92ED"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantagesIndividual);
export default __webpack_public_path__ + "static/media/advantages_individual.4e2c491e5fddd06c1b2640600fc0672b.svg";
export { ForwardRef as ReactComponent };